app.directive('newBookingDatepicker', function () {
    return {
        restrict: 'A',
        controllerAs: 'dir',
        scope: { date: '=newBookingDatepicker', minDate: '=minDate', offDays: '=offDays', dataLang: '=dataLang'},
        link: function (scope, element, attrs, ngModelCtrl) {
            element.datepicker( {
                inline: true,
                firstDay: 1,
                showOtherMonths: true,
                minDate: minDate,
                dateFormat: 'yy-mm-dd',
                onSelect: function (date) {
                    scope.date = element.datepicker('getDate');
                    scope.$apply();
                },
            });

            $('.ui-datepicker').addClass('notranslate');


            var language = attrs.lang;

            if (language.indexOf('bg') > -1){
                element.datepicker( "option", $.datepicker.regional[ "bg" ] );
            }else if (language.indexOf('pl') > -1){
                element.datepicker( "option", $.datepicker.regional[ "pl" ] );
            }else if (language.indexOf('pt') > -1){
                element.datepicker( "option", $.datepicker.regional[ "pt" ] );
            }else if (language.indexOf('cat') > -1 || language.indexOf('esn') > -1 || language.indexOf('euq') > -1 || language.indexOf('glc') > -1){
                element.datepicker( "option", $.datepicker.regional[ "es" ] );
            }else if (language.indexOf('lt') > -1){
                element.datepicker( "option", $.datepicker.regional[ "lt" ] );
            }else if (language.indexOf('id') > -1){
                element.datepicker( "option", $.datepicker.regional[ "id" ] );
            }else if (language.indexOf('de') > -1){
                element.datepicker( "option", $.datepicker.regional[ "de" ] );
            }else{
                element.datepicker( "option", $.datepicker.regional[ "en" ] );
            }

            scope.date = element.datepicker('getDate');

            scope.$watch('minDate', function (minDate) {
                if (minDate === undefined) return;

                var dateOpt = moment.isMoment(minDate) ? minDate.toDate() : minDate;
                element.datepicker('option', 'minDate', dateOpt);

                recalculateCurrentDate();
            });

            scope.$watch('offDays', function (offDays) {
                if (offDays === undefined) return;

                element.datepicker('option', 'beforeShowDay', filterDays);
                recalculateCurrentDate();
            });

            function recalculateCurrentDate() {
                var currentDate = moment(element.datepicker('getDate'));
                var maxTries = 30;

                // Try to find the next date which is allowed by the days filter;
                while (!filterDays(currentDate.toDate())[0] && maxTries--) {
                    currentDate.add(1, 'days');
                }
                element.datepicker('setDate', currentDate.toDate());
                scope.date = currentDate.toDate();
            }

            function filterDays(date) {
                if (scope.offDays == 'all' || scope.offDays === undefined) return [true, '', ''];
                var day = date.getDay();
                var dayIsAllowed = scope.offDays.indexOf(day) != -1;

                return [dayIsAllowed, '', ''];
            }
        }
    };
});


app.directive('jqdatepicker', function () {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function (scope, element, attrs, ngModelCtrl) {
            element.datepicker( {
                firstDay: 1,
                showOtherMonths: true,
                changeYear: true,
                yearRange: "-90:+0",
                dateFormat: 'mm-dd-yy',
                onSelect: function (date) {
                    scope.orderInfo.bdDate = date;
                    scope.$apply();
                }
            });
            $('.ui-datepicker').addClass('notranslate');

            var language = attrs.lang;

            if (language.indexOf('bg') > -1){
                element.datepicker( "option", $.datepicker.regional[ "bg" ] );
            }
            else if (language.indexOf('pl') > -1){
                element.datepicker( "option", $.datepicker.regional[ "pl" ] );
            }
            else if (language.indexOf('cat') > -1 || language.indexOf('esn') > -1 || language.indexOf('euq') > -1 || language.indexOf('glc') > -1){
                element.datepicker( "option", $.datepicker.regional[ "es" ] );
            }
            else if (language.indexOf('lt') > -1){
                element.datepicker( "option", $.datepicker.regional[ "lt" ] );
            }else if (language.indexOf('id') > -1){
                element.datepicker( "option", $.datepicker.regional[ "id" ] );
            }else if (language.indexOf('de') > -1){
                element.datepicker( "option", $.datepicker.regional[ "de" ] );
            }
            else{
                element.datepicker( "option", $.datepicker.regional[ "en" ] );
            }

        }
    };
});

app.directive('jqcalendar', function () {
    return {
        restrict: 'A',
        controllerAs: 'dir',
        scope: { date: '=jqcalendar', minDate: '=minDate', offDays: '=offDays', dataLang: '=dataLang'},
        link: function (scope, element, attrs, ngModelCtrl) {
            element.datepicker( {
                inline: true,
                firstDay: 1,
                showOtherMonths: true,
                minDate: minDate,
                dateFormat: 'yy-mm-dd',
                onSelect: function (date) {
                    scope.date = element.datepicker('getDate');
                    scope.$apply();
                },
            });
            $('.ui-datepicker').addClass('notranslate');


            var language = attrs.lang;

            if (language.indexOf('bg') > -1){
                element.datepicker( "option", $.datepicker.regional[ "bg" ] );
            }
            else if (language.indexOf('pl') > -1){
                element.datepicker( "option", $.datepicker.regional[ "pl" ] );
            }
            else if (language.indexOf('cat') > -1 || language.indexOf('esn') > -1 || language.indexOf('euq') > -1 || language.indexOf('glc') > -1){
                element.datepicker( "option", $.datepicker.regional[ "es" ] );
            }
            else if (language.indexOf('lt') > -1){
                element.datepicker( "option", $.datepicker.regional[ "lt" ] );
            }
            else if (language.indexOf('id') > -1){
                element.datepicker( "option", $.datepicker.regional[ "id" ] );
            }
            else if (language.indexOf('de') > -1){
                element.datepicker( "option", $.datepicker.regional[ "de" ] );
            }
            else{
                element.datepicker( "option", $.datepicker.regional[ "en" ] );
            }

            scope.date = element.datepicker('getDate');

            scope.$watch('minDate', function (minDate) {
                if (minDate === undefined) return;

                var dateOpt = moment.isMoment(minDate) ? minDate.toDate() : minDate;
                element.datepicker('option', 'minDate', dateOpt);

                recalculateCurrentDate();
            });

            scope.$watch('offDays', function (offDays) {
                if (offDays === undefined) return;

                element.datepicker('option', 'beforeShowDay', filterDays);
                recalculateCurrentDate();
            });

            function recalculateCurrentDate() {
                var currentDate = moment(element.datepicker('getDate'));
                var maxTries = 30;

                // Try to find the next date which is allowed by the days filter;
                while (!filterDays(currentDate.toDate())[0] && maxTries--) {
                    currentDate.add(1, 'days');
                }
                element.datepicker('setDate', currentDate.toDate());
                scope.date = currentDate.toDate();
            }

            function filterDays(date) {
                if (scope.offDays == 'all' || scope.offDays === undefined) return [true, '', ''];
                var day = date.getDay();
                var dayIsAllowed = scope.offDays.indexOf(day) != -1;

                return [dayIsAllowed, '', ''];
            }
        }
    };
});



app.directive('currency', function () {
    return {
        require: 'ngModel',

        link: function (elem, $scope, attrs, ngModelCtrl) {
            var tpl = '';

            var Currency = infoData.Currency;

            if (Currency == null)
                var Currency = "$";

            if (Currency == '$' || Currency == '€' || Currency == '£') {
                tpl = Currency + '{val}';
            }
            else {
                tpl = '{val} ' + Currency;
            }

            ngModelCtrl.$formatters.push(function (val) {
                //console.log(val)
                return tpl.replace('{val}', val.toFixed(2));
            });

            ngModelCtrl.$parsers.unshift(function (val) {
                //var regexp = new RegExp("\\" + Currency);
                //console.log(val)
                return 666;//val.replace(regexp, '');
            });

        }
    }
})

app.directive('numbersOnly', function () {
    return {
        require: 'ngModel',
        link: function (scope, element, attr, ngModelCtrl) {
            function fromUser(text) {
                if (text) {
                    var transformedInput = text.replace(/[^0-9]/g, '');

                    if (transformedInput !== text) {
                        ngModelCtrl.$setViewValue(transformedInput);
                        ngModelCtrl.$render();
                    }
                    return transformedInput;
                }
                return undefined;
            }
            ngModelCtrl.$parsers.push(fromUser);
        }
    };
});

app.directive('language', ["$translate", "$http", function ($translate, $http) {
    return {
        restrict: 'E',
        replace: true,
        template: '<div class="lang-nav"><a class="current" data-lang="{{curlang}}" ng-click="langon=!langon;">\
            			<i class="flag {{curlang}}"></i>\
                        {{curlang}}\
        			</a> \
                    <ul ng-show="langon">\
                    	<li ng-repeat="lang in languages track by $index">\
                    		<a ng-click="setLang(lang)" data-lang="{{lang}}" ng-hide="curlang==lang">\
                    			<i class="flag {{lang}}"></i>\
                                {{lang}}\
                			</a>\
            			</li>\
                    </ul></div>',
        link: function ($scope, el, attrs) {

            function setCookie(key, value) {
                var expires = new Date();
                expires.setTime(expires.getTime() + (1 * 24 * 60 * 60 * 1000));
                document.cookie = key + '=' + value + ';expires=' + expires.toUTCString() + ';path=/';
            }
        
            function getCookie(key) {
                var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
                return keyValue ? keyValue[2] : null;
            }

            getCultureLanguage();

            $scope.setLang = function (d) {
                $translate.use(d);
                setCookie('setLang', d);
                $scope.langon = false;
                $scope.curlang = d;
            }

            const lastLang = getCookie('setLang');

            if ( lastLang ) {
                $scope.curlang = lastLang;
                $translate.use(lastLang)
            }else{
                $scope.curlang = $scope.cultureLang ;
                $translate.use($scope.cultureLang );
            }   

            if(gym[0].Languages != null){
                $scope.languages = gym[0].Languages.split(',');
                if( !$scope.languages.includes($scope.cultureLang)){
					$scope.languages.push($scope.cultureLang);
				}
            }else{
                $scope.languages = ['en', 'bg', 'es', 'esc', 'pl','pt', 'esm', 'it', 'ro', 'de'];
                //  'lt', 'id', 
            }


            function getCultureLanguage(){
                if ($scope.Language.indexOf('bg') > -1) {
                    $scope.cultureLang = 'bg';
                }
                else if ($scope.Language.indexOf('esm') > -1 || $scope.Language.indexOf('esn') > -1 || $scope.Language.indexOf('euq') > -1) {
                    $scope.cultureLang = 'es';
                }else if($scope.Language.indexOf('cat') > -1 || $scope.Language.indexOf('glc') > -1){
                    $scope.cultureLang = 'esc';
                }else if ($scope.Language.indexOf('esm') > -1) {
                    $scope.cultureLang = 'esm';
                }else if ($scope.Language.indexOf('pl') > -1) {
                    $scope.cultureLang = 'pl';
                }else if ($scope.Language.indexOf('pt') > -1) {
                    $scope.cultureLang = 'pt';
                }else if ($scope.Language.indexOf('it') > -1) {
                    $scope.cultureLang = 'it';
                }else if ($scope.Language.indexOf('ro') > -1) {
                    $scope.cultureLang = 'ro';
                }else if ($scope.Language.indexOf('lt') > -1) {
                    $scope.cultureLang = 'lt';
                }else if ($scope.Language.indexOf('id') > -1) {
                    $scope.cultureLang = 'id';
                }else if ($scope.Language.indexOf('de') > -1) {
                    $scope.cultureLang = 'de';
                }
                else {
                    $scope.cultureLang = 'en';
                }
			}
        }
    };
}]);